import React from "react";
import { StrongText } from "../common";

export default function FounderNoteSection({ data }) {
  return (
    <section className="founder-note">
      <div className="container founder-container">
        <h2 className="heading">{data.title}</h2>
        <div className="founder-note-copy">
          <h2 className="heading">{data.strongtext}</h2>
          {data.paragraphs.map((paragraph) => (
            <p key={paragraph}>
              <StrongText>{paragraph}</StrongText>
            </p>
          ))}
          <div className="strong-data">{data.boldtext}</div>
        </div>
      </div>
    </section>
  );
}
